import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import{
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
  NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
  NbAuthJWTInterceptor,
} from '@nebular/auth';

//import { NbLoginComponent } from './auth/components/login/login.component';
import { APP_BASE_HREF } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxLoginComponent } from './auth/login/login.component';
import { NgxAuthComponent } from './auth/auth.component';
import { AuthGuard } from './auth.guard';
const formSetting: any = {
  redirectDelay: 0,
  showMessages: {
    success: true,
  },
  rememberMe: true,
};

const routes: Routes = [
  
  {
    path: 'auth',
    //component: NgxAuthComponent,
    loadChildren: () => import('./auth/auth.module')
      .then(m => m.NgxAuthModule),
    //children: [
    //  {
    //    path: '',
    //    component: NgxLoginComponent,
    //  },
    //  {
    //    path: 'login',
    //    component: NgxLoginComponent,
    //  },
    //  {
    //    path: 'register',
    //    component: NbRegisterComponent,
    //  },
    //  {
    //    path: 'logout',
    //    component: NbLogoutComponent,
    //  },
    //  {
    //    path: 'request-password',
    //    component: NbRequestPasswordComponent,
    //  },
    //  {
    //    path: 'reset-password',
    //    component: NbResetPasswordComponent,
    //  },
    //],
  },
  {
    path: 'pages',
    //canActivate: [AuthGuard],
    //canActivateChild: [AuthGuard],
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
  },
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
  providers: [
    //{ provide: APP_BASE_HREF, useValue: '/' },
    //{ provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true},
    //{ provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: function () { return false; } },    
  ],
})
export class AppRoutingModule {
}
